import axios from 'axios';
import Cookies from 'js-cookie';

// Replace this with your actual backend base URL if it's different
export const BASE_URL = 'https://inv.burrayhr.com/api';

// Create an axios instance that you can import and use across your application
const api = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

api.interceptors.request.use((config) => {
    const token = Cookies.get('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export default api;
